import { WhatsApp } from "@mui/icons-material";
import { Button } from "@mui/material";

function DialogCommonTitle({ dialogTitle, detailName, noWa }) {
    return (
        <>
            {dialogTitle} dari <i>{detailName}</i>
            <span style={{ float: "right" }}>
                <Button href={"https://wa.me/" + noWa + "?text=Assalamualaikum%20Saya%20ingin%20bertanya%20tentang,"} target="_blank" variant="contained" color="success" startIcon={<WhatsApp></WhatsApp>}>Hubungi</Button>
            </span>
        </>
    )
}

export default DialogCommonTitle;